import MainRoutes from "./routes";
import "react-circular-progressbar/dist/styles.css";

function App() {
  return <MainRoutes />;
}

export default App;
